import Vue from 'vue'
import './plugins/axios'
import './filters/currency'
import './filters/customFilters'
import App from './App.vue'
import router from './router'
import store from './store/store'
import vuetify from './plugins/vuetify';
import './assets/styles/app.scss'
import VueGtag from "vue-gtag";
import VueCardFormat from 'vue-credit-card-validation';
// import setupInterceptor from "./config/interceptorsConfig.js";

Vue.config.productionTip = false

Vue.use(VueGtag, {
  config: { 
    id: "G-CZJCTBT5F5",
  }
}, router);

Vue.use(VueCardFormat);


new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')

// setupInterceptor(window.axios, store, router);